// Inspired by: https://github.com/justinmc/react-audio-player/issues/149

import React from "react";

export default class AudioPlayer extends React.Component {
  constructor(props) {
    super(props)
    this.audioElement = React.createRef()
  }

  componentWillUnmount() {
    if (this.audioElement.current) {
      this.audioElement.current.pause();
      this.audioElement.current.src = '';
      this.audioElement.current.load();
    }
  }

  play = () => {
    this.audioElement.current.play();
  };

  pause = () => {
    this.audioElement.current.pause();
  };

  stop = () => {
    this.audioElement.current.pause();
    this.audioElement.current.currentTime = 0;
  };

  setSpeed = (speed) => {
    this.audioElement.current.playbackRate = speed;
  };

  setVolume = (volume) => {
    if (this.audioElement.current) {
      this.audioElement.current.volume = volume;
    }
  };

  render() {
    const { url, volume, shouldLoop, onFinishedPlaying, onPlay, onIsLoaded, onIsLoading } = this.props

    const volumeFloat = volume / 100
    this.setVolume(volumeFloat)

    return (
      <audio
        src={url}
        ref={this.audioElement}
        onPlay={onPlay}
        onEnded={onFinishedPlaying}
        loop={shouldLoop}
        onCanPlayThrough={onIsLoaded}
        onLoadedData={onIsLoading}
      >
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    );
  }
}
